<template>
    <header class="header" v-if="setup != null" id="header">
        <div class="container">
            <div class="header-container">
                <navMain class="header-navigation newyear-2021" v-if="projectHost != 'kohota'"></navMain>
                <div class="right-header">
                    <div class="mobile-menu" :class="{open: openSendwich}" @click="openMobileMenu(!openSendwich)" v-if="iSmobile">
                        <span></span>
                    </div>
                    <div class="lang">
                        <!-- v-if="projectHost != 'kohota'" -->
                        <div class="lang--picker">
                            <a href="#" class="lang-link-select" @click.prevent="openSelectLang = !openSelectLang">
                                <span class="body-lang-ru" v-if="dataLang == '' && projectHost != 'kohota'">Рус</span>
                                <span class="body-lang-ru" v-if="dataLang == 'ru' || dataLang == '' && projectHost == 'kohota'">RU</span>
                                <span class="body-lang-kz" v-if="dataLang == 'kz'">Қаз</span>
                                <span class="body-lang-kz" v-if="dataLang == 'uz'">UZ</span>
                            </a>
                        </div>
                        <div class="select--languages dropdown-menu" :class="{'open' : openSelectLang}">
                            <ul>
                                <li class="select-link select-link-ru" :class="{'active': dataLang == ''}">
                                    <a href="#" @click.prevent="setLocale(''), openSelectLang = !openSelectLang" v-if="projectHost != 'kohota'">Рус</a>
                                    <a href="#" @click.prevent="setLocale('ru/'), openSelectLang = !openSelectLang" v-if="projectHost == 'kohota'">RU</a>
                                </li>
                                <li class="select-link select-link-kz" :class="{'active': dataLang != ''}" v-if="projectHost != 'kohota'">
                                    <a href="#" @click.prevent="setLocale('kz/'), openSelectLang = !openSelectLang">Қаз</a>
                                </li>
                                <li class="select-link select-link-uz" :class="{'active': dataLang != ''}" v-if="projectHost == 'kohota'">
                                    <a href="#" @click.prevent="setLocale('uz/'), openSelectLang = !openSelectLang">UZ</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="city-select">
                        <div class="city-picker" v-if="currentPhone != null">
                            <a href="#" class="city-link-picker" @click.prevent>
                                <span>{{currentPhone.region}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="phone-current-city" v-if="currentPhone != null">
                        <a :href="'tel:' + currentPhone.region_phone" class="phone-number">{{currentPhone.region_phone}}</a>
                    </div>
                    <div class="logo-bazis" :class="{'logo-bazis-uz' : projectHost == 'kohota'}">
                        <a href="https://sales.bazis.kz" target="_blank" v-if="projectHost != 'kohota'">
                            <img src="https://admin.sales.bazis.kz/media/logo-bazis-enjoy.svg" alt="sales.bazis.kz BAZIS-A">
                        </a>
                        <!-- <a href="https://bazis-t.uz" target="_blank" v-if="projectHost == 'kohota'">
                            <img src="https://sales.bazis.kz/cms/media/2022/02/bazis-t_red.svg" alt="BAZIS-A UZ">
                        </a> -->
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import {mapGetters} from 'vuex'
    import navMain from '@/components/nav-main/nav-main.vue'
    export default {
        name: 'AppHeader',
        components: {
            navMain,
        },
        data () {
            return {
                regionCity: null,
                regionCityArr: null, 
                dropdownCity: false,
                iSmobile: false,
                currentPhone: null,
                openSelectLang: false,
                dataLang: '',
                projectHost: window.host,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            currentCity: 'loadCurCity',
            openSendwich: 'loadOpenSendwich',
        }),
        methods: {
            filterPhoneCity() {
                if (this.setup != null && this.currentCity != null) {
                    var data = this.setup.regions_name;
                    var filteredItems = data.filter(item => {
                        return item.region_lat.slug == this.currentCity.slug;
                    });
                    // console.log(filteredItems, 'CURRENT PHONE');
                    if (filteredItems.length > 0) {
                        this.currentPhone = filteredItems[0];
                    } else  {
                        // console.log('length error filtered cityes header');
                        this.currentPhone = '+7(727) 2 777-777';
                    }
                }
            },
            setLocale(lang) {
                localStorage.setItem('languageShablon', lang);
                document.location.reload(true);
            },
            changeLang () {
                this.dataLang = window.body.data('language');
                // console.log(this.dataLang)
            },
            openMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                    this.size = 4;
                    this.amount = 40;
                    this.speed = .5;
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.isMobileCheck();
            this.checkResize();
            this.filterPhoneCity();
            this.changeLang();
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue != null) {
                        this.changeLang();
                        this.filterPhoneCity();
                    }
                }
            );
            this.$store.watch(
                (state) => state.currentCity,
                (newValue) => {
                    this.changeLang();
                    this.filterPhoneCity();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/header/header.scss';
    @import '@/styles/respond/header/respond-header.scss';
</style>